import { usePermission } from "../../../shared/permissions";
import type { Permission } from "../../../shared/permissions";
import type { RegistrationById } from "../../../api/registrations.types";

const useHasPermissionToEdit = (permission: Permission) => {
  const { hasPermission } = usePermission();

  return ({ status, permissions }: RegistrationById) => {
    const isAllowedForStatus =
      status.status !== "review" || hasPermission("nova-forms-api:registration:review", permissions);

    return hasPermission(permission, permissions) && isAllowedForStatus;
  };
};

export const useHasPermissionToUpdateAnswers = () =>
  useHasPermissionToEdit("nova-forms-api:registration:answers:update");

export const useHasPermissionToChooseResponsible = () => {
  const hasPermissionToUpdate = useHasPermissionToEdit("nova-forms-api:registration:update");

  return (registration: RegistrationById) => registration.canChooseResponsible ?? hasPermissionToUpdate(registration);
};

export const useHasPermissionToUpdateMetaData = () => {
  const hasPermissionToUpdate = useHasPermissionToEdit("nova-forms-api:registration:update");

  return (registration: RegistrationById) =>
    hasPermissionToUpdate(registration) || registration.organisationEditability?.canUpdateUnits === true;
};
